<template>
  <div class="relative w-full">
    <remove-acc :show="isCurrent(1)" @next="next" @skip="done" />
    <wear-tight :show="isCurrent(2)" @next="next" @skip="done" />
    <tie-hair :show="isCurrent(3)" @next="next" @skip="done" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ScanProcess from '@/modules/scan-process';
import handleArmDetection from '@/mixins/arm-detection';
import page from '@/mixins/page';
import leave from '@/mixins/leave';

import WearTight from '../components/ThingsToNote/WearTight.vue';
import TieHair from '../components/ThingsToNote/TieHair.vue';
import RemoveAcc from '../components/ThingsToNote/RemoveAcc.vue';

export default {
  name: 'ThingsToNote',
  components: {
    WearTight,
    TieHair,
    RemoveAcc,
  },
  mixins: [page, handleArmDetection, leave],
  created() {
    if (this.skipTutorial) {
      this.done();
    } else {
      this.$nextTick(() => {
        this.next();
      });
    }
  },
  data: () => ({
    currentPageNo: 0,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.done();
      }
    },
    done() {
      if (ScanProcess.withHandles()) {
        this.$events.goto('ScanBodyWithHandles');
      } else if (this.skipTutorial) {
        this.startArmDetection();
        this.$events.goto('ScanBody');
      } else {
        this.$events.goto('ChooseToStart');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    ...mapState('mtmUser', ['skipTutorial']),
    lastScreen() {
      return this.currentPageNo >= 3;
    },
  },
};
</script>
